/** A menu is complete only when every selected dish has a valid dose and cost. */
export function eventMenuCost(
  selectedIds: readonly string[],
  costs: readonly { recipeId: string; costPerPortion: number | null }[],
  portions: Readonly<Record<string, string>>,
): number | null {
  if (!selectedIds.length) return null;
  let total = 0;
  for (const id of selectedIds) {
    const cost = costs.find((item) => item.recipeId === id)?.costPerPortion;
    const dose = Number((portions[id] ?? '1').replace(',', '.'));
    if (cost == null || !Number.isFinite(cost) || cost < 0 || !Number.isFinite(dose) || dose <= 0) return null;
    total += cost * dose;
  }
  return Number.isFinite(total) ? total : null;
}
